/* eslint-disable */
import {v4} from 'uuid'
import axios from 'axios'

const EVENTS = {
    //  `leaveSite` - Fires when visitor looks to navigate away from site or close tab/window
    leaveSite: 'leaveSite',
    // `ad` - Fires when ad related event fires
    ad: 'ad',
    // 'ad_render' Fires when ad_render event (custom event we fire through Adbridg) is triggered
    ad_render: 'ad_render',
    // 'ad_render' Fires when raw_ad_render event (custom event we fire through Adbridg) is triggered
    raw_ad_render:'raw_ad_render',
    // 'speed_event' Fires when a page speed event is triggered by the FE
    speed_event: 'speed_event'
}
const ps_events=[
    'first-contentful-paint',
    'text-paint',
    'first-input-delay'
]

function debugAnalytics(cb){
    window.addEventListener("debug",cb)
}

function leaveSite(cb){    
    window.addEventListener("pagehide",function(e){
        return cb(true)
    })
}

function adEvent(cb){
    window.googletag.cmd.push(() => {
                window.googletag.pubads().addEventListener('slotRequested', (e) => {
                    e.type='slotRequested'
                    cb(e)
                });
                window.googletag.pubads().addEventListener('slotResponseReceived', (e) => {
                    e.type='slotReceived'
                    cb(e)
                });
                window.googletag.pubads().addEventListener('slotOnload', (e) => {
                    e.type='slotOnload'                    
                    cb(e)
                });
                window.googletag.pubads().addEventListener('impressionViewable', (e) => {
                    e.type='impressionViewable'
                    cb(e)
                });
            })
    window.addEventListener("ad_render",function(e){
        return cb(e)
    })
    window.addEventListener("raw_ad_render",function(e){
        return cb(e)
    })
}

function publish(data,url){
    let blob = new Blob([JSON.stringify(data)], {type : 'text/plain'})
    navigator.sendBeacon(url,blob)
}

function resetData(data){
    data.p_events.length=0
    data.c_events.length=0
    data.a_events.length=0
    data.ps_events.length=0
}

function pageSpeed(cb){
    window.addEventListener("ps_event",(e) => {
        return cb(e.detail)
    })
}

export default function ltkPlugin(url=null,env="production") {
    let debug = false;
    const d = new Date()
    let data = {
        a_vers:1.3,
        s_id:v4(),
        u_id:null,
        tzone_o:d.getTimezoneOffset(),
        cc:null,
        reg:null,
        platform:null,
        s_vers:null,
        window_size:{},
        p_events:[],
        c_events:[],
        a_events:[],
        ps_events:[]
    }
    let init_url = null
    return {
        name: 'ltk-plugin',
        EVENTS: EVENTS,
        config: {
            url:url,
            env:env,
        },
        bootstrap: ({instance,config}) => {
            if (instance.storage.getItem("ltk_analytics_dbg","cookie") == true) debug = true;
            window.googletag = window.googletag || {cmd: []};
            if(instance.storage.getItem("__user_id","localStorage") == null){
                instance.storage.setItem("__user_id",v4(),"localStorage")
            }
            (async () => {
                try{
                    let loc = await axios.get("https://pro.ip-api.com/json/?key=AmUN9xAaQALVYu6")
                    data.cc = loc.data.countryCode
                    data.reg = loc.data.regionName
                }catch(e){
                    console.log(e)
                }
            })()
            leaveSite(leave => {
                instance.dispatch({
                    type: (leave) ? EVENTS.leaveSite : ""
                })
            })
            init_url = window.location.hostname+window.location.pathname
            if(window.dataLayer && window.dataLayer.length>0){
                window.dataLayer.forEach(event =>{
                    if(ps_events.some((value)=>{
                            return value == event.name}
                        )
                    ){
                        let ps_event = {
                            type:event.name,
                            id:event.id,
                            url:event.location,
                            tstamp:event.timestamp,
                            value:event.value,
                            label:event.label || null
                        }
                        debug ? console.log("there was a PS Event during bootstrap") : null
                        data.ps_events.push(ps_event)
                    }
                })
            }
            pageSpeed(event_data => {
                instance.dispatch({
                    type:EVENTS.speed_event,
                    detail:event_data
                })
            })
            adEvent(ad_data => {
                if(ad_data.hasOwnProperty("isTrusted")){
                    if(ad_data.type  == "raw_ad_render"){
                        instance.dispatch({
                            type:EVENTS.raw_ad_render,
                            ad_data:ad_data
                        })
                    }
                    else{
                        instance.dispatch({
                            type:EVENTS.ad_render,
                            ad_data:ad_data
                        })
                    }
                }else{
                    instance.dispatch({
                        type:EVENTS.ad,
                        ad_data:ad_data
                    })
                }
            })
        },
        page: ({payload,config}) => {
            let p_event = {
                url:payload.properties.url,
                referrer:payload.properties.referrer,
                tstamp:payload.meta.timestamp,
                type:payload.properties.type
            }
            if(p_event.type !== "tabHid") data.p_events.push(p_event)
            debug ? console.log(p_event) : null
                if(p_event.type == "leave" || p_event.type == "tabHid"){
                    let cp  = JSON.stringify(data)
                    cp = JSON.parse(cp)
                    if(p_event.type == 'tabHid' 
                    && ! (data.p_events[data.p_events.length - 1]["type"] == "leave")){
                        cp.p_events.push(p_event)
                        resetData(data)
                    }
                    else if(p_event.type == 'tabHid' 
                    && (data.p_events[data.p_events.length - 1]["type"] == 'leave')){
                        resetData(data)
                        return
                    }
                    publish(cp,config.url)
                    debug ? console.log(cp) : null
                    return
                }
            debug ? console.log(data) : null

        },
        loaded: () => {
            return true
        },
        ready: ({instance}) => {
            data.u_id = instance.user('userId')
            data.platform = navigator.userAgent
            data.window_size.width = window.innerWidth
            data.window_size.height = window.innerHeight
            switch(instance.getState().context.app){
                case 'wfw':
                    data.s_vers = instance.storage.getItem('wf_ab_exp','cookie') || null
                    break;
                case 'ydr':
                    data.s_vers = instance.storage.getItem('yd_ab_exp','cookie') || null
                    break;
                default:
                    data.s_vers = null
            }
            debug ? console.log(data) : null
            debugAnalytics(() => {
                debug = true
                instance.storage.setItem("ltk_analytics_dbg",true,"cookie")
            })
            

        },
        tabHidden: ({instance}) => {
            instance.page({type:'tabHid',url:window.location.hostname+window.location.pathname})

        },
        tabVisible: ({instance}) => {
            instance.page({type:'tabVis',url:window.location.hostname+window.location.pathname})

        },
        leaveSite: ({instance}) => {
            instance.page({type:'leave',url:window.location.hostname+window.location.pathname})
        },
        ad: ({payload}) => {
            let c_page = window.location.hostname+window.location.pathname
            let a_event = {
                slotId:payload.ad_data.slot.getSlotElementId(),
                type:payload.ad_data.type,
                tstamp:Date.now(),
                page: c_page
            }
            data.a_events.push(a_event)
            debug ? console.log(a_event) : null
        },
        raw_ad_render: ({payload}) => {
            let c_page = window.location.hostname+window.location.pathname
            let a_event = {
                slotId:payload.ad_data.detail.elem_id,
                type:payload.ad_data.type,
                tstamp:Date.now(),
                page: c_page,
                refreshCounter: payload.ad_data.detail.refresh_counter,
                filled:!payload.ad_data.detail.is_empty,
                advertiserId:payload.ad_data.detail.advertiser_id,
                campaignId:payload.ad_data.detail.campaign_id,
                creativeId:payload.ad_data.detail.creative_id

            }
            data.a_events.push(a_event)
        },
        ad_render: ({payload}) => {
            let c_page = window.location.hostname+window.location.pathname
            data.a_events.forEach(a_event => {
                let payload_data = payload.ad_data.detail
                if(a_event.page == c_page && a_event.slotId ==payload_data.elem_id 
                    && a_event.type == "raw_ad_render" &&  a_event.refreshCounter == payload_data.refresh_counter){
                    if(typeof payload.ad_data.detail.winner != "undefined" &&  payload.ad_data.detail.winner){
                        a_event.winningBidCpm = payload.ad_data.detail.winner.cpm
                        a_event.winningBidder = payload.ad_data.detail.winner.config.bidder_name 
                    }
                    debug ? console.log(a_event) : null
                }
            });
        },
        speed_event: ({payload}) => {
            let ps_event = {
                type:payload.detail.name,
                id:payload.detail.id,
                url:payload.detail.location,
                tstamp:payload.detail.timestamp,
                value:payload.detail.value,
                label:payload.detail.label || null
            }
            debug ? console.log(ps_event) : null
            if(ps_events.some((value)=>{return value == ps_event.type})){
                if(!data.p_events[0] || (data.p_events[0] && ps_event.url == init_url)){
                    data.ps_events.push(ps_event)
                }
                debug ? console.log(data.ps_events) : null
            }
        }
    }
  }



// WEBPACK FOOTER //
// ./src/common/Analytics_Plugin.js